<div class="header-container">
  <div>
    <mat-form-field>
      <mat-label>Search for an ingredient</mat-label>
      <input #ingredientSearch matInput type="text" [formControl]="ingredientFormControl"
             data-qa="qa-input"
             (input)="onInputChangedFilterData('name')">
    </mat-form-field>
  </div>
  <div class=" header-spacer"></div>
  <div>
    <button [routerLink]="'/pharmacy-management/add-ingredient'" mat-raised-button color="accent">
      <mat-icon>add</mat-icon> Add Ingredient
    </button>
  </div>
</div>

<div *ngIf="!ingredientDataSource" class="center-container">
  <mat-spinner></mat-spinner>
</div>

<div *ngIf="ingredientDataSource" class="mat-elevation-z8 table-container">
  
  <table mat-table multiTemplateDataRows [dataSource]="ingredientDataSource" #ingredientSort="matSort"
         matSort (matSortChange)="sortData($event)">
    
    <ng-container matColumnDef="icons">
      <th *matHeaderCellDef mat-header-cell></th>
      <td *matCellDef="let row" mat-cell>
        <mat-icon class="table-icon" #editIngredientTooltip="matTooltip"
                  matTooltip="EDIT Ingredient" (click)="editEntry($event, row.ingredientId)">edit
        </mat-icon>
        <mat-icon class="table-icon" #deleteIngredientTooltip="matTooltip"
                  matTooltip="DELETE Ingredient" (click)="deleteEntry($event, row.ingredientId)">
          delete</mat-icon>
      </td>
    </ng-container>
    
    <ng-container matColumnDef="ingredientId">
      <th *matHeaderCellDef mat-header-cell mat-sort-header> ID</th>
      <td *matCellDef="let row" mat-cell> {{row.ingredientId}}</td>
    </ng-container>
    
    <ng-container matColumnDef="name">
      <th *matHeaderCellDef mat-header-cell mat-sort-header> Ingredient Name</th>
      <td *matCellDef="let row" mat-cell> {{row.name}}</td>
    </ng-container>
    
    <ng-container matColumnDef="pubchemName">
      <th *matHeaderCellDef mat-header-cell mat-sort-header> Pubchem Name</th>
      <td *matCellDef="let row" mat-cell> {{row.pubchemName}}</td>
    </ng-container>
    
    <ng-container matColumnDef="source">
      <th *matHeaderCellDef mat-header-cell mat-sort-header> Source</th>
      <td *matCellDef="let row" mat-cell>
        <app-open-link-as *ngIf="row.source"
                          [icon]="DisplayIcon.ExternalIcon" [url]="row.source"
                          (onClick)="$event.stopPropagation()">
        </app-open-link-as>
        {{row.source}}
      </td>
    </ng-container>
    
    <ng-container matColumnDef="expandedDetail">
      <td *matCellDef="let row" mat-cell [attr.colspan]="ingredientDisplayedColumns.length">
        <div class="row-detail-container"
             [@detailExpand]="row == ingredientExpandedRow ? 'expanded' : 'collapsed'">
          <b>Mesh: </b>{{row.mesh}}<br>
          <b>Pharmacological Classification: </b>{{row.pharmacologicalClassification}}<br>
          <b>FDA Pharmacology: </b>{{row.fdaPharmacology}}<br>
          <b>Created By: </b>{{row.createdBy}}<br>
          <b>Created Date: </b>{{row.created | date: dateTimeFormat}}<br>
          <b>Updated By: </b>{{row.updatedBy}}<br>
          <b>Updated Date: </b>{{row.updated | date: dateTimeFormat}}<br>
        </div>
      </td>
    </ng-container>
    
    <tr mat-header-row *matHeaderRowDef="ingredientDisplayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: ingredientDisplayedColumns;" class="row"
        [class.expanded-row]="ingredientExpandedRow == row"
        (click)="ingredientExpandedRow = ingredientExpandedRow === row ? null : row">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row"></tr>
  
  </table>
  
  <mat-paginator #ingredientPaginator (page)="pageChanged($event)"
                 [length]="ingredientTableControl.length" [pageSize]="ingredientTableControl.pageSize"
                 [pageIndex]="0" [pageSizeOptions]="ingredientTableControl.pageSizeOptions">
  </mat-paginator>

</div>
